import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPack } from '@stockcare-models/IPack';

@Component({
  standalone: false,
  selector: 'app-packs-card',
  templateUrl: './packs-card.component.html',
  styleUrls: ['./packs-card.component.scss'],
})
export class PacksCardComponent {
  toggleState: boolean;

  @Input() pack: IPack;
  @Output() packClicked = new EventEmitter<IPack>();

  cardClicked() {
    this.packClicked.emit(this.pack);
  }
}
